var definitionListItem = 'fx_2d2fb1e5_17s06wu0';

export { definitionListItem };
//# sourceMappingURL=definitionListItem.vanilla.mjs.map
